import { generatePath, type MatchParams, type Query, type Route } from 'react-resource-router-next';

export const preloadRouteComponent = (route: Route) => {
	if (
		route.component &&
		'preload' in route.component &&
		typeof route.component.preload === 'function'
	) {
		route.component.preload();
	}
};

/**
 * Replaces the last segment of the current path with the specified property.
 * @param property - The new segment to replace the last part of the path.
 * @returns The updated path.
 * @TODO RAGE-586 should not use `window.location.pathname` as it does not work with MemoryRouter in integration tests
 * @deprecated Construct a path using the route object itself i.e `generalEditRoute.path`. This function relies on literal path names which are brittle.
 */
export const replaceLastPathSegment = (property: string): string => {
	// Use the provided path or fallback to the current browser path
	const currentPath = window.location.pathname;
	const pathSegments = currentPath.split('/');

	// Replace the last segment with the new property
	pathSegments[pathSegments.length - 1] = property;

	// Join the segments back into a valid path
	return pathSegments.join('/');
};

export const excludeQueryParams = (
	query: Query,
	keysToExclude: string[],
): { [key: string]: string } => {
	return Object.fromEntries(
		Object.entries(query)
			.filter(([key]) => !keysToExclude.includes(key))
			.map(([key, value]) => [key, value as string]),
	);
};

export const usePathUtils = () => {
	return {
		generatePath: (path: string, params?: MatchParams): string => {
			return generatePath(path, params);
		},
		matchPath: (path: string, routePath: string): boolean => {
			return path === routePath;
		},
	};
};
